<template>
  <div id="app">
    <!-- Mostrar el Navbar solo en rutas que comiencen con /dashboard -->
    <Navbar v-if="showNavbar" />

    <!-- Contenedor principal -->
    <main class="bg-gray-100 ">
      <div class="app">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import Navbar from "@/components/NavBar.vue";

export default {
  components: {
    Navbar,
  },
  setup() {
    const route = useRoute();

    // Mostrar el Navbar solo si la ruta comienza con /dashboard
    const showNavbar = computed(() => route.path.startsWith("/dashboard"));

    return {
      showNavbar,
    };
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  position: relative;
}
main .app{
  position: relative;
  padding-top: 40px;
  width: 95vw;
  max-width: 1600px;
  margin: 0 auto;
  // transition: margin-left 0.3s;

  /* Ajusta el margen izquierdo dinámicamente si el Navbar está visible */
  // &.ml-64 {
  //   margin-left: 16rem; /* 64px x 4 (ancho del menú) */
  // }
}
h1 {
  text-align: center;
}
</style>
